"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _vueFroala = _interopRequireDefault(require("./vue-froala"));

var _default = _vueFroala["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vue-froala-wysiwyg/es/index.js
// module id = 9fd9
// module chunks = 0